import { BaseError } from './common/BaseError';
/**
 * Use to signal about invalid schema for generate app
 * This error means nodes DSL is broken.
 */
export class SchemaValidationError extends BaseError {
}
